module.exports = __webpack_public_path__ + "img/title_cover.6a64122.png";